import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Autocomplete,
  Box,
  Button,
  createFilterOptions,
  Dialog,
  DialogActions,
  DialogTitle,
  TextField,
} from '@mui/material';
import DivForm from 'src/components/ModalDialogMUI6/styled/DivForm';
import { STYLE_OPTIONS } from 'src/constants';

const filterOptions = createFilterOptions({
  stringify: ({
    label, value
  }) => `${label} ${value}`
});

const isOptionEqualToValue = (option, value) => value?.value && value?.value === option?.value;

const renderOptionAutocomplete = (props, option) => (
  <div
    {...props}
    style={{
      alignItems: 'start',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <b>{option.label}</b>
    <Box
      sx={{
        color: STYLE_OPTIONS.COLOR_BLUE,
        fontFamily: STYLE_OPTIONS.FONT_FAMILY,
        fontSize: '12px',
      }}
    >
      {option.value}
    </Box>
  </div>
);

function ModalInsertDynamicFields({
  isModalVisible,
  dynamicFields,
  onInsert,
  onCloseModal,
}) {
  const [selectedField, setSelectedField] = useState(null);

  const cpDynamicFields = useMemo(
    () => dynamicFields
      .filter((field) => (field?.screens?.includes('All') || field?.screens?.includes('Chat')) && field?.softwareName === 'Connection Point')
      .map((field) => ({
        label: field?.description,
        value: field?.value,
      })),
    [dynamicFields]
  );

  const handleClose = () => {
    onCloseModal();
    setSelectedField(null);
  };

  const handleInsert = () => {
    const selectedDynamicField = selectedField?.value || null;
    if (selectedDynamicField) {
      onInsert(selectedDynamicField);
    }
    handleClose();
  };

  return (
    <Dialog
      open={isModalVisible}
      fullWidth
      maxWidth="sm"
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: '8px',
          padding: '24px',
        },
      }}
    >
      <Box
        sx={{
          padding: '0 0 0 16px',
          textAlign: 'center',
        }}
      >
        <DialogTitle
          sx={{
            fontSize: '18px',
            padding: 0,
          }}
        >
          Select Dynamic Fields & Insert
        </DialogTitle>
      </Box>
      <DivForm>
        <Autocomplete
          options={cpDynamicFields || []}
          value={selectedField}
          filterOptions={filterOptions}
          renderOption={renderOptionAutocomplete}
          isOptionEqualToValue={isOptionEqualToValue}
          onChange={(e, value) => setSelectedField(value)}
          renderInput={(params) => (
            <TextField
              label="Dynamic Fields"
              placeholder="Search or select a dynamic field"
              {...params}
            />
          )}
          handleHomeEndKeys
          selectOnFocus
          clearOnBlur
        />
      </DivForm>
      <DialogActions
        sx={{
          padding: 0,
          justifyContent: 'center',
        }}
      >
        <Button
          onClick={handleClose}
          sx={{
            ...STYLE_OPTIONS.BUTTON_PRIMARY_REVERSED,
            minWidth: '105px',
            marginRight: '14px',
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleInsert}
          disabled={!selectedField?.value}
          sx={{
            ...STYLE_OPTIONS.BUTTON_PRIMARY,
            minWidth: '105px',
          }}
        >
          Insert
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ModalInsertDynamicFields.propTypes = {
  isModalVisible: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onInsert: PropTypes.func.isRequired,
  dynamicFields: PropTypes.array,
};
ModalInsertDynamicFields.defaultProps = {
  dynamicFields: [],
};

export default ModalInsertDynamicFields;
